"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_bill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "6c6e43a9-f474-4df6-b3bd-646016da4c2d",
    "data-name": "bill-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a01b69f4-5c50-4295-b7fc-15af639ce53e",
    x1: 125.08,
    y1: 44.36,
    x2: 159.64,
    y2: 78.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "bill-hi"), /*#__PURE__*/React.createElement("g", {
    id: "dc16ca5c-f0ca-4962-a2ae-ea5131429b33",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3ef888a4-4e05-4eba-aaf6-09a280901076",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,44V160h0a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16h0V56H128a16,16,0,0,1-16-16V16H56A16,16,0,0,0,40,32V44",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.8,
    y: 130,
    width: 72,
    height: 4,
    rx: 1.41,
    ry: 1.41,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.8,
    y: 146,
    width: 24,
    height: 4,
    rx: 1.41,
    ry: 1.41,
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,56H128a16,16,0,0,1-16-16V16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,54a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h24l-2-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,56c-.53,0-1,0-1.57-.08l-.61-.09c-.3,0-.6-.07-.89-.13s-.53-.12-.8-.19-.43-.1-.64-.17-.6-.19-.9-.3l-.47-.17c-.33-.13-.65-.28-1-.43l-.32-.15c-.35-.18-.69-.36-1-.56l-.19-.12c-.36-.22-.71-.46-1.05-.7l-.09-.07c-.36-.27-.71-.55-1-.84h0L152,86.56V56Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#a01b69f4-5c50-4295-b7fc-15af639ce53e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,174H56a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 36,
    r: 8,
    fill: "#e60000"
  }))));
}

var _default = ic_bill;
exports.default = _default;